import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center', 
    backgroundColor: '#f8f9fa',
    color: '#343a40',
    padding: '20px'
  };

  const titleStyle = {
    fontSize: '6rem',
    fontWeight: 'bold',
    margin: '0',
    color: '#dc3545'
  };

  const messageStyle = {
    fontSize: '1.5rem',
    margin: '20px 0'
  };

  const buttonStyle = {
    padding: '10px 20px',
    fontSize: '1rem',
    color: '#fff',
    backgroundColor: '#007bff',
    border: 'none',
    borderRadius: '5px',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s'
  };

  return (
    <div style={containerStyle}>
         <h1 style={titleStyle}>404</h1>
         <h2 style={{ fontSize: '2rem', margin: '10px 0' }}> صفحه پیدا نشد.</h2>
         <p style={messageStyle}>
                 صفحه‌ای که به دنبال آن هستید حذف شده یا آدرس آن را اشتباه وارد کرده‌اید.
         </p>
         <Link to="/" style={buttonStyle}>
           بازگشت به صفحه اصلی
         </Link>
       </div>
  );
};

export default NotFound;
